// src/components/table/TableHeader.jsx
import React from "react";
import OcrHeaderBlock from "./OcrHeaderBlock";

export default function TableHeader({
  th,
  divider,
  hoveredColumn,
  setHoveredColumn,
  setSortColumn,
}) {
  return (
    <thead>
      <tr>
        <th
          style={{ ...th, width: "120px", cursor: "pointer" }}
          onClick={() => setSortColumn(null)}
        >
          Symbol
        </th>

        <th style={{ ...th, width: "220px" }}>Name</th>

        <OcrHeaderBlock
          label="Daily"
          hoverKey="daily"
          sortIndex={4}
          percentIndex={3}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          setSortColumn={setSortColumn}
          th={th}
          divider={{}}
        />

        <OcrHeaderBlock
          label="3Hour"
          hoverKey="h3"
          sortIndex={15}
          percentIndex={14}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          setSortColumn={setSortColumn}
          th={th}
          divider={divider}
        />

        <OcrHeaderBlock
          label="2Hour"
          hoverKey="h2"
          sortIndex={26}
          percentIndex={25}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          setSortColumn={setSortColumn}
          th={th}
          divider={divider}
        />

        <OcrHeaderBlock
          label="1Hour"
          hoverKey="h1"
          sortIndex={37}
          percentIndex={36}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          setSortColumn={setSortColumn}
          th={th}
          divider={divider}
        />

        <OcrHeaderBlock
          label="weekly"
          hoverKey="weekly"
          sortIndex={48}
          percentIndex={47}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          setSortColumn={setSortColumn}
          th={th}
          divider={divider}
        />
      </tr>
    </thead>
  );
}
